import { render, staticRenderFns } from "./CustomVid.vue?vue&type=template&id=6e640758&"
import script from "./CustomVid.vue?vue&type=script&lang=js&"
export * from "./CustomVid.vue?vue&type=script&lang=js&"
import style0 from "./CustomVid.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports